// A2 - Ünite 1: Past Simple - Olumlu
// Hedef: Was/Were, düzenli/düzensiz fiiller, geçmiş zaman

export const A2_UNIT_1 = {
  'A2-U1-L1': {
    id: 'A2-U1-L1',
    title: 'Was / Were (To Be Geçmiş)',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Was / Were - Geçmiş Zaman "To Be"',
          explanation: 'Present tense\'daki "am/is/are" geçmiş zamanda "was/were" olur. Türkçede "-di/-dı" ekine karşılık gelir.',
          table: {
            headers: ['Özne', 'Geçmiş', 'Örnek', 'Türkçesi'],
            rows: [
              ['I', 'was', 'I was a student.', 'Öğrenciydim.'],
              ['You', 'were', 'You were at the airport.', 'Havalimanındaydın.'],
              ['He/She/It', 'was', 'She was tired.', 'Yorgundu.'],
              ['We', 'were', 'We were cabin crew.', 'Kabin ekibiydik.'],
              ['They', 'were', 'They were on time.', 'Zamanındaydılar.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Havacılık Örnekleri',
          table: {
            headers: ['Cümle', 'Türkçesi', 'Durum'],
            rows: [
              ['The flight was delayed.', 'Uçuş rötar yaptı.', 'Rötar'],
              ['The passengers were happy.', 'Yolcular mutluydu.', 'Memnuniyet'],
              ['I was at Gate 12.', '12 numaralı kapıdaydım.', 'Konum'],
              ['The weather was bad.', 'Hava kötüydü.', 'Hava durumu']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 I, He, She, It = WAS | You, We, They = WERE'
        },
        {
          type: 'vocabulary',
          title: '✈️ Geçmiş Zaman Kelimeleri',
          words: [
            { en: 'yesterday', tr: 'dün', pronunciation: '/ˈjestədeɪ/' },
            { en: 'last week', tr: 'geçen hafta', pronunciation: '/lɑːst wiːk/' },
            { en: 'last month', tr: 'geçen ay', pronunciation: '/lɑːst mʌnθ/' },
            { en: 'ago', tr: 'önce', pronunciation: '/əˈɡəʊ/' },
            { en: 'in 2023', tr: '2023\'te', pronunciation: '' }
          ]
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'I _____ at the airport yesterday.',
          options: ['was', 'were', 'am', 'is'],
          correct: 'was',
          explanation: 'I ile was kullanılır'
        },
        {
          type: 'multipleChoice',
          question: 'The passengers _____ tired after the long flight.',
          options: ['was', 'were', 'is', 'are'],
          correct: 'were',
          explanation: 'Passengers (çoğul) ile were kullanılır'
        },
        {
          type: 'fillInBlank',
          sentence: 'She _____ a flight attendant for 5 years.',
          answer: 'was',
          hint: 'She ile was'
        },
        {
          type: 'matching',
          instruction: 'Özneleri doğru fiillerle eşleştirin',
          pairs: [
            { left: 'I', right: 'was' },
            { left: 'You', right: 'were' },
            { left: 'They', right: 'were' },
            { left: 'The plane', right: 'was' }
          ]
        },
        {
          type: 'dragDrop',
          instruction: '🔀 Cümleyi doğru sıraya dizin',
          words: ['yesterday', 'was', 'I', 'tired'],
          correctOrder: [2, 1, 3, 0],
          translation: 'Dün yorgundum.'
        },
        {
          type: 'flashcard',
          title: '🎴 Was/Were Kartları',
          cards: [
            { front: 'I was', back: '(Ben) ...dım/dim' },
            { front: 'You were', back: '(Sen) ...dın/din' },
            { front: 'He/She was', back: '(O) ...dı/di' },
            { front: 'We were', back: '(Biz) ...dık/dik' },
            { front: 'They were', back: '(Onlar) ...dılar/diler' }
          ]
        },
        {
          type: 'timeRace',
          title: '⏱️ Was mı Were mı?',
          cards: [
            { front: 'I ___', back: 'was' },
            { front: 'You ___', back: 'were' },
            { front: 'He ___', back: 'was' },
            { front: 'She ___', back: 'was' },
            { front: 'We ___', back: 'were' },
            { front: 'They ___', back: 'were' },
            { front: 'It ___', back: 'was' }
          ]
        }
      ]
    }
  },
  'A2-U1-L2': {
    id: 'A2-U1-L2',
    title: 'Düzenli Fiiller (-ed)',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Past Simple - Düzenli Fiiller',
          explanation: 'Düzenli fiillerde geçmiş zaman için fiilin sonuna -ed eklenir. Tüm öznelerle aynı form kullanılır.',
          table: {
            headers: ['Fiil', 'Geçmiş', 'Örnek', 'Türkçesi'],
            rows: [
              ['work', 'worked', 'I worked yesterday.', 'Dün çalıştım.'],
              ['check', 'checked', 'She checked the cabin.', 'Kabini kontrol etti.'],
              ['serve', 'served', 'We served drinks.', 'İçecek servis ettik.'],
              ['help', 'helped', 'They helped passengers.', 'Yolculara yardım ettiler.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '📝 -ed Yazım Kuralları',
          table: {
            headers: ['Kural', 'Örnek', 'Geçmiş'],
            rows: [
              ['Genel: +ed', 'work, check', 'worked, checked'],
              ['-e ile biten: +d', 'serve, arrive', 'served, arrived'],
              ['sessiz+y: y→ied', 'carry, study', 'carried, studied'],
              ['sesli+y: +ed', 'play, stay', 'played, stayed'],
              ['kısa sesli+ünsüz: çift', 'stop, plan', 'stopped, planned']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 -ed okunuşu: /t/ (worked), /d/ (served), /ɪd/ (landed)'
        },
        {
          type: 'vocabulary',
          title: '✈️ Havacılık Düzenli Fiilleri',
          words: [
            { en: 'landed', tr: 'indi', pronunciation: '/ˈlændɪd/' },
            { en: 'departed', tr: 'kalktı', pronunciation: '/dɪˈpɑːtɪd/' },
            { en: 'boarded', tr: 'bindi', pronunciation: '/ˈbɔːdɪd/' },
            { en: 'announced', tr: 'anons etti', pronunciation: '/əˈnaʊnst/' },
            { en: 'delayed', tr: 'gecikti', pronunciation: '/dɪˈleɪd/' }
          ]
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'The plane _____ at 3 PM. (land)',
          options: ['landed', 'land', 'lands', 'landing'],
          correct: 'landed',
          explanation: 'Geçmiş zaman: land → landed'
        },
        {
          type: 'multipleChoice',
          question: 'She _____ the passengers with their luggage. (help)',
          options: ['helped', 'help', 'helps', 'helpped'],
          correct: 'helped',
          explanation: 'Geçmiş zaman: help → helped'
        },
        {
          type: 'fillInBlank',
          sentence: 'We _____ (serve) meals during the flight.',
          answer: 'served',
          hint: '-e ile biten fiillere sadece -d eklenir'
        },
        {
          type: 'fillInBlank',
          sentence: 'The flight _____ (delay) for 2 hours.',
          answer: 'delayed',
          hint: 'delay → delayed'
        }
      ]
    }
  },
  'A2-U1-L3': {
    id: 'A2-U1-L3',
    title: 'Düzensiz Fiiller (Irregular Verbs)',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Past Simple - Düzensiz Fiiller',
          explanation: 'Bazı fiillerin geçmiş zamanı kuralsızdır. Bunları ezberlemek gerekir!',
          table: {
            headers: ['Fiil', 'Geçmiş', 'Türkçesi', 'Örnek'],
            rows: [
              ['go', 'went', 'gitmek', 'I went to the airport.'],
              ['come', 'came', 'gelmek', 'She came early.'],
              ['see', 'saw', 'görmek', 'We saw the captain.'],
              ['have', 'had', 'sahip olmak', 'They had a meeting.'],
              ['do', 'did', 'yapmak', 'He did his job well.'],
              ['take', 'took', 'almak', 'I took the bags.'],
              ['get', 'got', 'almak/olmak', 'We got on the plane.'],
              ['make', 'made', 'yapmak', 'She made an announcement.'],
              ['say', 'said', 'söylemek', 'The captain said...'],
              ['give', 'gave', 'vermek', 'I gave instructions.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Havacılık Düzensiz Fiilleri',
          table: {
            headers: ['Fiil', 'Geçmiş', 'Havacılık Örneği'],
            rows: [
              ['fly', 'flew', 'The plane flew to Paris.'],
              ['speak', 'spoke', 'She spoke to the passengers.'],
              ['tell', 'told', 'He told them to sit down.'],
              ['know', 'knew', 'I knew the procedure.'],
              ['think', 'thought', 'We thought it was turbulence.'],
              ['find', 'found', 'They found the lost item.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Düzensiz fiilleri öğrenmenin en iyi yolu: go-went-gone gibi üçlü liste halinde ezberlemek!'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'The plane _____ to Istanbul yesterday. (fly)',
          options: ['flew', 'flied', 'flyed', 'fly'],
          correct: 'flew',
          explanation: 'fly → flew (düzensiz)'
        },
        {
          type: 'multipleChoice',
          question: 'She _____ the safety demonstration. (do)',
          options: ['did', 'done', 'doed', 'does'],
          correct: 'did',
          explanation: 'do → did (düzensiz)'
        },
        {
          type: 'fillInBlank',
          sentence: 'I _____ (go) to the briefing room.',
          answer: 'went',
          hint: 'go → went'
        },
        {
          type: 'matching',
          instruction: 'Fiilleri geçmiş formlarıyla eşleştirin',
          pairs: [
            { left: 'go', right: 'went' },
            { left: 'see', right: 'saw' },
            { left: 'fly', right: 'flew' },
            { left: 'have', right: 'had' },
            { left: 'take', right: 'took' }
          ]
        }
      ]
    }
  },
  'A2-U1-L4': {
    id: 'A2-U1-L4',
    title: 'Zaman İfadeleri (Time Expressions)',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Past Simple ile Kullanılan Zaman İfadeleri',
          explanation: 'Geçmiş zamanla belirli zaman ifadeleri kullanılır. Bunlar cümlenin sonunda veya başında yer alabilir.',
          table: {
            headers: ['İfade', 'Türkçesi', 'Örnek'],
            rows: [
              ['yesterday', 'dün', 'I worked yesterday.'],
              ['last week/month/year', 'geçen hafta/ay/yıl', 'She flew last week.'],
              ['... ago', '... önce', 'We met 2 days ago.'],
              ['in 2023', '2023\'te', 'The airline started in 2023.'],
              ['on Monday', 'Pazartesi günü', 'He arrived on Monday.'],
              ['at 5 PM', 'saat 17:00\'de', 'The flight departed at 5 PM.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Uçuş Zamanları',
          table: {
            headers: ['Cümle', 'Zaman İfadesi'],
            rows: [
              ['The flight landed 30 minutes ago.', '30 dakika önce'],
              ['We departed yesterday morning.', 'dün sabah'],
              ['The delay happened last night.', 'dün gece'],
              ['She started working here in 2020.', '2020\'de']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 "ago" her zaman geçmiş zamanla kullanılır ve zaman ifadesinden SONRA gelir: 2 hours ago ✓'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'The flight arrived 2 hours _____.',
          options: ['ago', 'before', 'last', 'yesterday'],
          correct: 'ago',
          explanation: '"ago" sayıdan sonra gelir: 2 hours ago'
        },
        {
          type: 'fillInBlank',
          sentence: 'She joined the company _____ year.',
          answer: 'last',
          hint: 'geçen yıl = last year'
        },
        {
          type: 'multipleChoice',
          question: 'We _____ to Dubai last month.',
          options: ['flew', 'fly', 'flied', 'will fly'],
          correct: 'flew',
          explanation: '"last month" geçmiş zaman gerektirir'
        }
      ]
    }
  },
  'A2-U1-L5': {
    id: 'A2-U1-L5',
    title: 'Uygulama: Uçuş Raporu',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '✈️ Uçuş Raporu Örneği',
          explanation: 'Kabin ekibi uçuş sonrası rapor yazarken geçmiş zaman kullanır:',
          table: {
            headers: ['Rapor Cümlesi', 'Türkçesi'],
            rows: [
              ['Flight TK123 departed at 08:00.', 'TK123 saat 08:00\'de kalktı.'],
              ['We served breakfast to 180 passengers.', '180 yolcuya kahvaltı servis ettik.'],
              ['There was light turbulence over the Alps.', 'Alpler üzerinde hafif türbülans vardı.'],
              ['A passenger felt sick and we assisted him.', 'Bir yolcu rahatsızlandı ve yardım ettik.'],
              ['The flight landed safely at 11:30.', 'Uçuş güvenli bir şekilde 11:30\'da indi.'],
              ['We had no major incidents during the flight.', 'Uçuş sırasında büyük bir olay yaşanmadı.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Mülakattta "Tell me about a difficult situation" sorusunda geçmiş zaman kullanın!'
        },
        {
          type: 'vocabulary',
          title: '✈️ Rapor Kelimeleri',
          words: [
            { en: 'incident', tr: 'olay', pronunciation: '/ˈɪnsɪdənt/' },
            { en: 'turbulence', tr: 'türbülans', pronunciation: '/ˈtɜːbjʊləns/' },
            { en: 'safely', tr: 'güvenli bir şekilde', pronunciation: '/ˈseɪfli/' },
            { en: 'departure', tr: 'kalkış', pronunciation: '/dɪˈpɑːtʃə/' },
            { en: 'arrival', tr: 'varış', pronunciation: '/əˈraɪvl/' }
          ]
        }
      ],
      exercises: [
        {
          type: 'fillInBlank',
          sentence: 'The flight _____ (depart) on time.',
          answer: 'departed',
          hint: 'depart → departed'
        },
        {
          type: 'fillInBlank',
          sentence: 'We _____ (have) a medical emergency.',
          answer: 'had',
          hint: 'have → had (düzensiz)'
        },
        {
          type: 'multipleChoice',
          question: 'There _____ no delays yesterday.',
          options: ['were', 'was', 'are', 'is'],
          correct: 'were',
          explanation: 'No delays (çoğul) ile were'
        },
        {
          type: 'speaking',
          instruction: 'Bir uçuşu geçmiş zamanda anlatın:',
          phrases: [
            'The flight departed at...',
            'We served...',
            'There was/were...',
            'The flight landed at...'
          ]
        }
      ]
    }
  },
  'A2-U1-EXAM': {
    id: 'A2-U1-EXAM',
    title: 'Ünite 1 Sınavı',
    type: 'exam',
    exercises: [
      {
        type: 'multipleChoice',
        question: 'I _____ at the airport yesterday.',
        options: ['was', 'were', 'am', 'be'],
        correct: 'was',
        explanation: 'I ile was kullanılır'
      },
      {
        type: 'multipleChoice',
        question: 'The passengers _____ happy with the service.',
        options: ['were', 'was', 'is', 'are'],
        correct: 'were',
        explanation: 'Passengers (çoğul) ile were'
      },
      {
        type: 'multipleChoice',
        question: 'She _____ the cabin before takeoff. (check)',
        options: ['checked', 'check', 'checks', 'checking'],
        correct: 'checked',
        explanation: 'Geçmiş zaman: check → checked'
      },
      {
        type: 'multipleChoice',
        question: 'The plane _____ to London. (fly)',
        options: ['flew', 'flied', 'flyed', 'fly'],
        correct: 'flew',
        explanation: 'fly → flew (düzensiz)'
      },
      {
        type: 'fillInBlank',
        sentence: 'We _____ (go) to the briefing room.',
        answer: 'went',
        hint: 'go → went'
      },
      {
        type: 'fillInBlank',
        sentence: 'The flight arrived 2 hours _____.',
        answer: 'ago',
        hint: 'Geçmiş zaman ifadesi'
      },
      {
        type: 'matchPairs',
        instruction: 'Fiilleri geçmiş formlarıyla eşleştirin',
        pairs: [
          { left: 'work', right: 'worked' },
          { left: 'fly', right: 'flew' },
          { left: 'go', right: 'went' },
          { left: 'have', right: 'had' }
        ]
      }
    ]
  }
};

export default A2_UNIT_1;
